import React, { useMemo } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import {
  CONNECTIONS_BASE_PATH,
  CONNECTIONS_INSTALL_PATH,
  CONNECTIONS_JOURNAL_S3_PATH,
  CONNECTIONS_RECOVERY_PATH,
  getConnectionsSection,
} from '../../config/connections-routes';
import '../../styles/connections.css';

const CONNECTION_TABS = [
  { key: 'list', path: CONNECTIONS_BASE_PATH, label: 'Список' },
  { key: 'recovery', path: CONNECTIONS_RECOVERY_PATH, label: 'Восстановление' },
  { key: 'install', path: CONNECTIONS_INSTALL_PATH, label: 'Установка' },
  { key: 'journal-s3', path: CONNECTIONS_JOURNAL_S3_PATH, label: 'Журналы S3' },
];

const ConnectionsLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const activeSection = useMemo(
    () => getConnectionsSection(location.pathname),
    [location.pathname]
  );

  const handleTabClick = (path) => {
    if (location.pathname === path) {
      return;
    }

    navigate(path);
  };

  return (
    <div className="pm-content-fade-in">
      <div className="conn-shell-header">
        <div className="conn-shell-header__main">
          <h1 className="conn-shell-header__title">Подключения</h1>
          <div className="conn-shell-header__tabs" role="tablist" aria-label="Разделы подключений">
            {CONNECTION_TABS.map((tab) => {
              const isActive = tab.key === activeSection;

              return (
                <button
                  key={tab.key}
                  type="button"
                  role="tab"
                  aria-selected={isActive}
                  className={`conn-section-chip${isActive ? ' conn-section-chip--active' : ' conn-section-chip--outline'}`}
                  onClick={() => handleTabClick(tab.path)}
                  tabIndex={0}
                >
                  <span className="conn-section-chip__label">{tab.label}</span>
                </button>
              );
            })}
          </div>
        </div>
      </div>

      <Outlet />
    </div>
  );
};

export default ConnectionsLayout;
